export default () => {
    const buttons = document.querySelectorAll('[data-anchor]');
    for (const button of buttons) {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const holder = document.querySelector(button.getAttribute('href'));
            if (holder) {
                holder.scrollIntoView();
            }
            return false;
        });
    }
}
